import type { BackendApi } from '../backend/client'

export function createCheckoutSession(
  api: BackendApi,
  params: { successUrl: string; cancelUrl: string; priceId: string },
) {
  return api.createStripeCheckoutSession({
    success_url: params.successUrl,
    cancel_url: params.cancelUrl,
    price_id: params.priceId,
  })
}

export function createTeamCheckoutSession(
  api: BackendApi,
  params: {
    successUrl: string
    cancelUrl: string
    orgName: string
    quantity: number
    isUpgrade?: boolean
    billingInterval?: 'month' | 'year'
  },
) {
  return api.createStripeTeamCheckoutSession({
    success_url: params.successUrl,
    cancel_url: params.cancelUrl,
    org_name: params.orgName,
    quantity: params.quantity,
    is_upgrade: params.isUpgrade,
    billing_interval: params.billingInterval,
  })
}

export function createPortalSession(api: BackendApi, returnUrl?: string) {
  return api.createStripePortalSession(returnUrl === undefined ? undefined : { return_url: returnUrl })
}

/** Upgrades the caller's Solo subscription to Family in place (proration, no new checkout). */
export function upgradeSubscription(api: BackendApi) {
  return api.upgradeStripeSubscription()
}
